import useResizeObserver from '@react-hook/resize-observer';
import { RefObject, useLayoutEffect, useState } from 'react';

export const useObserveSize = (targetRef: RefObject<HTMLElement> | HTMLElement | null) => {
  const [size, setSize] = useState<DOMRectReadOnly>(new DOMRectReadOnly());
  const targetElement = targetRef instanceof HTMLElement ? targetRef : targetRef ? targetRef.current : null;

  useLayoutEffect(() => {
    if (!targetElement) return;

    setSize(targetElement.getBoundingClientRect());
  }, [targetElement]);

  useResizeObserver(targetElement, (entry: ResizeObserverEntry) => {
    setSize(entry.contentRect);
  });

  return size;
};
